module.exports = __webpack_public_path__ + "assets/img/add-folder_new.a41f92f8.svg";